import type { SVGProps } from 'react';
const SvgArrowBackIos = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#arrow_back_ios_svg__a)">
      <path
        fill="currentColor"
        d="M11.67 3.87 9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12l8.13-8.13Z"
      />
    </g>
    <defs>
      <clipPath id="arrow_back_ios_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgArrowBackIos;
